/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Status_Subtitle_ActiveInputs */

const en_admin_company_detail_status_subtitle_active = /** @type {(inputs: Admin_Company_Detail_Status_Subtitle_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active companies appear on the admin dashboard and their job positions are visible to candidates.`)
};

const de_admin_company_detail_status_subtitle_active = /** @type {(inputs: Admin_Company_Detail_Status_Subtitle_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Unternehmen erscheinen im Admin-Dashboard und ihre Stellen sind für Bewerber:innen sichtbar.`)
};

/**
* | output |
* | --- |
* | "Active companies appear on the admin dashboard and their job positions are visible to candidates." |
*
* @param {Admin_Company_Detail_Status_Subtitle_ActiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_status_subtitle_active = /** @type {((inputs?: Admin_Company_Detail_Status_Subtitle_ActiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Status_Subtitle_ActiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_status_subtitle_active(inputs)
	return en_admin_company_detail_status_subtitle_active(inputs)
});